import http from "../../http";

const task = {
    selectTaskPage(r) {
        return  http.spin.get("/gateway/api/v2/message/task/selectTaskPage",r )
    },

}
export default task
